module.exports = __webpack_public_path__ + "static/media/kocsag.2f4d447c.gif";